<template>
  <div class="row">
    <template v-if="!loading">
      <b-col xs="12" md="4" class="quick-glance-widget">
        <div class="d-flex flex-column quick-glance-link">
          <div class="quick-glance-number">
            {{ displayData.pending || 0 }}
          </div>
          <div class="quick-glance-text">
            <span class="invoice-text">
              {{ $t('dashboard.quickGlance.helpTexts.advancePending') }}
            </span>
          </div>
          <router-link
            :to="{ name: 'invoices', params: { selectedFilter: 'pending' } }"
            v-track-click
            id="quick-glance-pending"
            class="view-invoices-button"
          >
            {{ $t('dashboard.quickGlance.viewInvoices') }}
            <b-icon-chevron-right class="ml-2 color-wealthy-green-500" />
          </router-link>
        </div>
      </b-col>
      <b-col xs="12" md="4" class="quick-glance-widget">
        <div class="d-flex quick-glance-link">
          <div class="quick-glance-number">
            {{ displayData.outstanding || 0 }}
          </div>
          <div class="quick-glance-text">
            <span class="invoice-text">
              {{ $t('dashboard.quickGlance.helpTexts.invoiceAdvanced') }}
            </span>
          </div>
          <router-link
            :to="{ name: 'invoices', params: { selectedFilter: 'advanced' } }"
            v-track-click
            id="quick-glance-advaced"
            class="view-invoices-button"
          >
            {{ $t('dashboard.quickGlance.viewInvoices') }}
            <b-icon-chevron-right class="ml-2 color-wealthy-green-500" />
          </router-link>
        </div>
      </b-col>
      <b-col xs="12" md="4" class="quick-glance-widget">
        <div class="d-flex quick-glance-link">
          <div class="quick-glance-number">
            {{ displayData.received || 0 }}
          </div>
          <div class="quick-glance-text">
            <span class="invoice-text">
              {{ $t('dashboard.quickGlance.helpTexts.settlementsPending') }}
            </span>
          </div>
          <router-link
            :to="{ name: 'invoices', params: { selectedFilter: 'paid' } }"
            v-track-click
            id="quick-glance-settlement"
            class="view-invoices-button"
          >
            {{ $t('dashboard.quickGlance.viewInvoices') }}
            <b-icon-chevron-right class="ml-2 color-wealthy-green-500" />
          </router-link>
        </div>
      </b-col>
    </template>
    <div class="col-sm-12" v-else>
      <loader :height="60" />
    </div>
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'

export default {
  props: ['loading', 'invoiceStageCounters'],
  computed: {
    displayData() {
      if (this.invoiceStageCounters === {}) {
        return false
      } else {
        let displayData = {}
        for (let group in this.invoiceStageCounters.groups) {
          displayData[group] = 0
          this.invoiceStageCounters.groups[group].forEach((element) => {
            if (
              typeof this.invoiceStageCounters.counters[element] !== 'undefined'
            ) {
              displayData[group] += this.invoiceStageCounters.counters[element]
            }
          })
        }
        return displayData
      }
    }
  },
  components: {
    Loader
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.quick-glance-number {
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  flex: 0 0 auto;
  margin-right: 1rem;
  color: $noble-blue-500;
}

.quick-glance-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: $noble-blue-500;
  margin-bottom: 8px;
}

.invoice-type {
  font-size: 2rem;
  line-height: 1.6rem;
}

.invoice-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: $noble-blue-500;
}

.quick-glance-link {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 24px 12px 16px;
  background: $white;
  border: 1px solid $sky-blue-400;
  border-radius: 8px;
  height: 100%;
}
.view-invoices-button {
  font-family: 'Nunito Sans';
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: $wealthy-green-500;
  cursor: pointer;
  margin-top: auto;
  width: max-content;
  border-radius: 8px;
  padding: 9px 8px;
  &:hover {
    background: $wealthy-green-50;
    text-decoration: underline;
  }
}
@include media-breakpoint-down(sm) {
  .quick-glance-number {
    font-size: 2rem;
    line-height: 2.5rem;
  }
  .invoice-type {
    font-size: 1.5rem;
    line-height: 1.6rem;
  }
  .quick-glance-widget {
    margin-bottom: 12px;
  }
}
</style>
